// Monument Hebrew mapping - EXACT match to IMG_6327.jpeg chart
// Reading left to right from the image

// First row: B through O
export const monumentChartRow1 = [
  { hebrew: 'ג', english: 'B', name: 'Gimel' },
  { hebrew: 'ב', english: 'C', name: 'Bet' },
  { hebrew: 'ך', english: 'D', name: 'Kaf Sofit' },
  { hebrew: 'ק', english: 'E', name: 'Qof' },
  { hebrew: 'כ', english: 'F', name: 'Kaf' },
  { hebrew: 'ע', english: 'G', name: 'Ayin' },
  { hebrew: 'י', english: 'H', name: 'Yod' },
  { hebrew: 'ן', english: 'I', name: 'Nun Sofit' },
  { hebrew: 'ח', english: 'J', name: 'Chet' },
  { hebrew: 'ל', english: 'K', name: 'Lamed' },
  { hebrew: 'ו', english: 'L', name: 'Vav' },
  { hebrew: 'צ', english: 'M', name: 'Tsadi' },
  { hebrew: 'מ', english: 'N', name: 'Mem' },
  { hebrew: 'ם', english: 'O', name: 'Mem Sofit' },
];

// Second row: P R S T U V X Y 1 2 3 : , .
export const monumentChartRow2 = [
  { hebrew: 'פ', english: 'P', name: 'Peh' },
  { hebrew: 'ר', english: 'R', name: 'Resh' },
  { hebrew: 'ד', english: 'S', name: 'Dalet' },
  { hebrew: 'א', english: 'T', name: 'Aleph' },
  { hebrew: 'ז', english: 'U', name: 'Zayin' },
  { hebrew: 'ה', english: 'V', name: 'Heh' },
  { hebrew: 'ס', english: 'X', name: 'Samech' },
  { hebrew: 'ט', english: 'Y', name: 'Tet' },
  { hebrew: 'ל', english: '1', name: 'Lamed' },
  { hebrew: 'נ', english: '2', name: 'Nun' },
  { hebrew: 'ש', english: '3', name: 'Shin' },
  { hebrew: 'ף', english: ':', name: 'Peh Sofit' },
  { hebrew: 'ת', english: ',', name: 'Tav' },
  { hebrew: 'ץ', english: '.', name: 'Tsadi Sofit' },
];

// Combine all chart letters
export const allMonumentChartLetters = [...monumentChartRow1, ...monumentChartRow2];

// Create monument Hebrew mapping
export const monumentHebrewMapping = {};
allMonumentChartLetters.forEach(item => {
  monumentHebrewMapping[item.english.toLowerCase()] = item.hebrew;
  monumentHebrewMapping[item.english.toUpperCase()] = item.hebrew;
});

// Add space
monumentHebrewMapping[' '] = ' ';

// Function to convert text using monument Hebrew mapping
export const convertToMonumentHebrew = (text) => {
  return text
    .split('')
    .map(char => monumentHebrewMapping[char] || char)
    .join('');
};

// Keep the original full Hebrew alphabet for the keyboard component
export const hebrewLetters = [
  { hebrew: 'א', english: 'A', name: 'Aleph' },
  { hebrew: 'ב', english: 'B', name: 'Bet' },
  { hebrew: 'ג', english: 'C', name: 'Gimel' },
  { hebrew: 'ד', english: 'D', name: 'Dalet' },
  { hebrew: 'ה', english: 'E', name: 'Heh' },
  { hebrew: 'ו', english: 'F', name: 'Vav' },
  { hebrew: 'ז', english: 'G', name: 'Zayin' },
  { hebrew: 'ח', english: 'H', name: 'Chet' },
  { hebrew: 'ט', english: 'I', name: 'Tet' },
  { hebrew: 'י', english: 'J', name: 'Yod' },
  { hebrew: 'כ', english: 'K', name: 'Kaf' },
  { hebrew: 'ל', english: 'L', name: 'Lamed' },
  { hebrew: 'מ', english: 'M', name: 'Mem' },
  { hebrew: 'נ', english: 'N', name: 'Nun' },
  { hebrew: 'ס', english: 'O', name: 'Samech' },
  { hebrew: 'ע', english: 'P', name: 'Ayin' },
  { hebrew: 'פ', english: 'Q', name: 'Peh' },
  { hebrew: 'צ', english: 'R', name: 'Tsadi' },
  { hebrew: 'ק', english: 'S', name: 'Qof' },
  { hebrew: 'ר', english: 'T', name: 'Resh' },
  { hebrew: 'ש', english: 'U', name: 'Shin' },
  { hebrew: 'ת', english: 'V', name: 'Tav' },
];

// Final forms (Sofit)
export const finalForms = [
  { hebrew: 'ך', english: 'k', name: 'Kaf Sofit' },
  { hebrew: 'ם', english: 'm', name: 'Mem Sofit' },
  { hebrew: 'ן', english: 'n', name: 'Nun Sofit' },
  { hebrew: 'ף', english: 'f', name: 'Peh Sofit' },
  { hebrew: 'ץ', english: 'r', name: 'Tsadi Sofit' },
];

// Common symbols
export const symbols = [
  { hebrew: ' ', english: ' ', name: 'Space' },
  { hebrew: '.', english: '.', name: 'Period' },
  { hebrew: ',', english: ',', name: 'Comma' },
  { hebrew: ':', english: ':', name: 'Colon' },
  { hebrew: ';', english: ';', name: 'Semicolon' },
  { hebrew: '"', english: '"', name: 'Quote' },
  { hebrew: "'", english: "'", name: 'Apostrophe' },
  { hebrew: '-', english: '-', name: 'Dash' },
  { hebrew: '(', english: '(', name: 'Left Paren' },
  { hebrew: ')', english: ')', name: 'Right Paren' },
];

// Common abbreviations
export const commonAbbreviations = [
  { hebrew: 'ב״ה', english: 'B"H', name: 'Baruch Hashem' },
  { hebrew: 'ע״ה', english: 'A"H', name: 'Alav HaShalom (male)' },
  { hebrew: 'ע״ה', english: 'A"H', name: 'Aleha HaShalom (female)' },
  { hebrew: 'ז״ל', english: 'Z"L', name: 'Zichrono Livracha (male)' },
  { hebrew: 'ת.נ.צ.ב.ה', english: 'T.N.Z.B.H', name: 'Tehi Nishmato Tzrura Bitzror HaChaim' },
  { hebrew: 'פ״נ', english: 'P"N', name: 'Po Nikbar/Nikberet' },
];

// Standard keyboard mapping (for editor use)
export const englishToHebrew = {};
hebrewLetters.forEach(item => {
  englishToHebrew[item.english.toLowerCase()] = item.hebrew;
  englishToHebrew[item.english.toUpperCase()] = item.hebrew;
});

finalForms.forEach(item => {
  englishToHebrew[item.english] = item.hebrew;
});

symbols.forEach(item => {
  englishToHebrew[item.english] = item.hebrew;
});

// Function for keyboard auto-convert
export const convertToHebrew = (text) => {
  return text
    .split('')
    .map(char => englishToHebrew[char] || char)
    .join('');
};

// All letters for keyboard display
export const allLetters = [...hebrewLetters, ...finalForms, ...symbols.slice(0, 10)];
